import { Container, Box } from "@mui/material"

import getValueFromLocalizedStringWithFallback from "../../utils/i18n/getValueFromLocalizedStringWithFallback"

import { IntermediateCategoryWithProducts } from "../../typings/Category"

const TopElement = ({ category, locale }: Props) => {
	const { nameAllLocales, shortSeoText } = category
	const name = getValueFromLocalizedStringWithFallback(nameAllLocales, locale)

	return (
		<Container>
			<Box pt={5}>
				<h1 style={{ textAlign: "center" }}>{name}</h1>
				{shortSeoText && shortSeoText.de && (
					<div
						style={{ marginTop: "2rem" }}
						dangerouslySetInnerHTML={{ __html: shortSeoText.de }}
					></div>
				)}
			</Box>
		</Container>
	)
}

interface Props {
	category: IntermediateCategoryWithProducts
	locale: string
}

export default TopElement
